// library imports
import { useState } from "react";
// hook imports
import useFetch from "./useFetch";

export default function useHasGensetSelected() {
  const [fetchWrapper] = useFetch();

  // loading state
  const [getHasGensetSelectedLoading, setGetHasGensetSelectedLoading] =
    useState(false);

  // this state is to check whether the site has genset
  const [hasGensetSelected, setHasGensetSelected] = useState(false);

  /* API to check whether site has genset that is selected and not deleted */
  function getHasGensetSelected({ siteSelected }) {
    setGetHasGensetSelectedLoading(true);
    fetchWrapper({
      endpoint_url: "layout/getHasGensetSelected",
      method: "GET",
      set_content_type_header: false,
      params: {
        site_id: siteSelected,
      },
      onSuccess: (response) => {
        setGetHasGensetSelectedLoading(false);
        setHasGensetSelected(response.data);
      },
    });
  }

  return [hasGensetSelected, getHasGensetSelected, getHasGensetSelectedLoading];
}
